<template>
  <form class="video-form" @submit.prevent="onSubmit">
    <b-loading v-if="videos.loadingSelected" active :is-full-page="false" />
    <mc-error-layout
      v-else-if="videos.selectError"
      message="Failed to load video!"
      :retry-fn="() => selectVideo(id)"
    />
    <div v-else class="video-form__body">
      <b-field label="Name">
        <b-input
          v-model="videos.selected.name"
          icon="format-title"
          placeholder="Name"
          type="text"
        />
      </b-field>
      <b-field label="Video URL">
        <b-input
          v-model="videos.selected.url"
          icon="link"
          placeholder="Video URL"
          type="text"
        />
      </b-field>
      <b-field label="Unique link">
        <b-field>
          <b-input
            ref="uniqueIdTextField"
            :value="uniqueId"
            placeholder="Video URL"
            type="text"
            expanded
            readonly
          />
          <p class="control">
            <b-button type="is-info" icon-right="content-copy" @click="copy" />
          </p>
        </b-field>
      </b-field>
      <b-field label="Subtitles URL (SRT file)">
        <b-field>
          <b-input
            v-model="videos.selected.subtitlesUrl"
            icon="link"
            expanded
            placeholder="Subtitles URL"
            type="text"
          />
          <p class="control">
            <b-button
              type="is-info"
              icon-right="upload"
              @click="uploadSubtitle"
            />
          </p>
        </b-field>
      </b-field>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import { copyToClipboard } from '../../utils/string';
import { openMcFileUploadModal } from '../../ui/general';

export default {
  props: {
    id: String,
    onSubmit: {
      type: Function,
      // eslint-disable-next-line
      default: () => {
        /* Does nothing */
      }
    }
  },
  computed: {
    ...mapState(['videos']),
    uniqueId() {
      return `${this.videos.selected.ownerId.id}/${this.videos.selected.id}`;
    }
  },
  methods: {
    ...mapActions('videos', ['selectVideo', 'updateSelectedSubtitles']),
    copy() {
      copyToClipboard(this.uniqueId);
      this.$buefy.toast.open({
        message: 'Copied!',
        type: 'is-success'
      });
    },
    getVideoPath() {
      return this.videos.selected.url.replace('/transcoded/360p.mp4', '');
    },
    async uploadSubtitle() {
      try {
        const uploadedSubtitleUrl = await openMcFileUploadModal(this, {
          resourceState: 'videos',
          fieldName: 'subtitles',
          title: 'Upload Subtitle (SRT)',
          accept: '.srt',
          pathPrefix: _ =>
            `${this.getVideoPath().replace('gcs:///', '')}/subtitles`
        });
        this.updateSelectedSubtitles(uploadedSubtitleUrl);
      } catch (e) {
        this.$buefy.toast.open({
          message: `Uploading subtitles ${
            e === 'escape' || e === 'x' || e == 'outside'
              ? 'canceled'
              : 'failed'
          }!`,
          type: 'is-danger'
        });
      }
    },
    submit: function() {
      this.onSubmit();
    }
  },
  created() {
    this.selectVideo(this.id);
  }
};
</script>

<style lang="scss" scoped>
.video-form {
  position: relative;
  height: 100%;

  &__body {
    padding: 1rem;
  }
}
</style>
